import styled from 'styled-components';

import {
  colorWhite,
  colorGreen,
  colorGrayLight,
  pSmall,
  colorGrey400,
} from 'styles';
import Checkbox from 'components/commons/Checkbox';
import Flag from 'components/Flag';

export const Wrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: stretch;
  width: 100%;
  background: ${colorWhite};
  height: 100%;
  border-radius: 2px;
`;

export const VisibilitySensorWrapper = styled.div`
  overflow: auto;
  flex: 100%;

  &::-webkit-scrollbar-track {
    background-color: #fff;
  }

  &::-webkit-scrollbar {
    width: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    max-height: 50px;
  }
`;

export const CurrenciesList = styled.div`
  min-height: 50px;

  ${({ isFocused }) => {
    if (isFocused) {
      return 'padding-top: 26px;';
    }

    return '';
  }}
`;

// TODO: Refactor
export const CheckboxWrapper = styled.div`
  padding: 12px 16px;
  width: 100%;

  &:hover,
  &:active {
    background-color: #f6f8fa;
  }
`;

export const CurrencyCheckbox = styled(Checkbox)`
  width: 100%;
`;

export const CurrencyName = styled.span`
  font-size: 12px;
  color: ${colorGrey400};
  margin-left: 4px;
`;

export const CurrencyFlag = styled(Flag)`
  margin-right: 8px;
  transform: scale(0.7, 0.7);
`;

export const SaveButton = styled.button`
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  padding: 15px 16px;
  transition: 0.3s;
  position: absolute;
  bottom: 16px;
  left: calc(50%);
  transform: translateX(-50%);
  justify-content: center;
  width: 174px;
  border-radius: 24px;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.16);
  background: ${colorWhite};
  color: ${colorGreen};
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
  text-transform: uppercase;
  border: 0;

  &:hover,
  &:active {
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.24);
  }
`;

export const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 24px auto;
`;

export const NoDataLabel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const OptionsTitle = styled.div`
  ${pSmall}

  background: ${colorGrayLight};
  padding: 9px 16px 4px;
`;
